<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error': showError}">
        <div class="info">{{ 'global.infoRequired' | translate}}</div>
        <div class="entry-3-modal" [ngClass]="{'show-error':showError}">
            <label>{{'mantenimiento-etiquetas.etiqueta.nombreEtiqueta' | translate}} *</label>
            <input type="text" formControlName="des">
        </div>
        <div class="entry-3-modal" [ngClass]="{'show-error':showError}">
            <label>{{'mantenimiento-etiquetas.etiqueta.listado' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="versionesNiceLabel"
                [selectedItem]="newEditForm.get('versionNiceLabel')" [disabled]="disabledLabel" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-3-modal" [ngClass]="{'show-error':showError}">
            <label>{{'mantenimiento-etiquetas.etiqueta.tipoConfeccion' | translate}} *</label>
            <app-filterable-list [itemsList]="tipos" [selectedItem]="newEditForm.get('tipoConfeccion')" [disabled]="disabledConfeccion" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div class="entry-1" style="margin: .5em .8em">
            <label>{{'mantenimiento-etiquetas.etiqueta.observaciones' | translate}}</label>
            <textarea formControlName="observaciones"></textarea>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{grupoEtiquetaId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event">
</app-toast>